export const PlansData = [
    {
        id: 1,
        frequency: 'Billed Monthly',
        price: '$50',
        type: 'Basic',
        show: 50,
        title: 'Basic Monthly Subscription Plan',
        details: 'Unlimited videos for 1 month',
        remark: 'Minimum Plan'
    },
    {
        id: 2,
        frequency: 'Billed Annually',
        price: '$100',
        type: 'Premium',
        show: 100,
        title: 'Premium Yearly Subscription Plan',
        details: 'Unlimited videos for 1 year',
        remark: 'Most Popular Plan'
    },
    {
        id: 3,
        frequency: 'Billed Quarterly',
        price: '$75',
        show: 75,
        type: 'Standard',
        title: 'Standard Quarterly Subscription Plan',
        details: 'Unlimited videos for  4 months',
        remark: 'Preferred Plan'
    }

]